import React from 'react'
import './ui.css'

function DetailList ({ children, className = '' }) {
  return <dl className={`ds-detail-list ${className}`.trim()}>{children}</dl>
}

function DetailListItem ({ label, children, className = '' }) {
  return (
    <div className={`ds-detail-list__row ${className}`.trim()}>
      <dt className="ds-detail-list__label">{label}</dt>
      <dd className="ds-detail-list__value">{children}</dd>
    </div>
  )
}

DetailList.Item = DetailListItem

export default DetailList
export { DetailListItem }
